import useSWRImmutable from 'swr';
import { CountryCode } from '../../urls-config';

export interface AuthenticationState {
  authenticated: boolean;
  registerUrl: string;
  signInUrl: string;
  signOutUrl: string;
}

export interface TrimContext {
  authenticationState: AuthenticationState;
  currentLocale: string;
  domainCountryCode: CountryCode;
  firstName: string;
  footerLinks: Record<string, string>;
  isDisputeEnabled: boolean;
  isRetractEnabled: boolean;
  supportedLanguages: string[];
  textDirection: string;
  weblabContextMap: Record<string, string>;
}

export interface TrimContextResponse {
  context?: TrimContext;
  error: any;
  isError: boolean;
}

const GET_TRIM_URL = '/report/infringement/api/trim';

export function useTrimContext(): TrimContextResponse {
  const { data, error } = useSWRImmutable<TrimContext>(GET_TRIM_URL, async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('An error occurred while fetching trim context data');
    }
    return response.json();
  });

  return {
    context: data,
    error,
    isError: !!error,
  };
}
